module.exports = __webpack_public_path__ + "img/1.093d89ac.png";